import { Group, Table } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchField } from '../../components/SearchField';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilterPageAndSearch } from '../../util/api/queryWithFilterPageAndSearch';
import { ProductCostRow } from './components/ProductCostRow';
import type { ProductCostDto } from './types/ProductCostDto';
import { KeyedRow } from '../../components/KeyedRow';

export function ProductCost() {
	const { organisation } = useParams();
	const pagination = usePagination();
	const filter = useFilter();
	const [searchQuery, setSearchQuery] = useState('');

	const productCostCountQuery = queryWithFilterPageAndSearch<number>(
		`${organisation}/product-cost/count`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const productCostQuery = queryWithFilterPageAndSearch<ProductCostDto[]>(
		`${organisation}/product-cost/all`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	return (
		<>
			<PageHeader title={'Product Cost'} hideFiltering>
				<Group>
					<SearchField
						placeholder={'Search products...'}
						onDelayComplete={(value) => setSearchQuery(value)}
					/>
				</Group>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={productCostCountQuery.data?.value}
				isRowsLoading={productCostQuery.isLoading}
				isPaginationLoading={productCostCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'SKUID'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Department'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Supplier Code'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Case Qty'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Case Cost'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Edit'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{productCostQuery.data?.value.map((product) => (
						<ProductCostRow product={product} key={product.skuid} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
